import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { SnackbarService } from '@widgets/site-common/snackbar/snackbar.service';
import { environment } from 'src/environments/environment';
import { sentryConfig } from './sentry-config';

Sentry.init(sentryConfig);

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  private get matSnackBar(): SnackbarService {
    return this.injector.get(SnackbarService);
  }
  constructor(private injector: Injector) {
    super();
  }
  // tslint:disable-next-line: no-any
  handleError(error: any) {
    if (error === null) {
      return;
    }
    super.handleError(error);
    let displayError = true;
    if (error.promise && error.rejection && error.rejection.status) {
      error = error.rejection;
    }
    if (error.status) {
      if ([400, 401].includes(error.status)) {
        return;
      }
      if ([403, 404].includes(error.status) || error.rejection.status >= 500) {
        displayError = false;
      }
    }

    let eventId = '';
    if (environment.production && environment.env) {
      eventId = Sentry.captureException(error.originalError || error);
      if (eventId) {
        console.error('Sentry Event Id', eventId);
      }
    }
    if (displayError && !this.matSnackBar.isOpen) {
      try {
        this.matSnackBar.dismiss();
        if (!sentryConfig.ignoreErrors.some(t => t.test(error.message))) {
          this.matSnackBar.error(error.message, error.stack);
        }
      } catch (err) {
        console.error('Failed to display error', err);
      }
    }
  }
}
